export const DEPLOYMENT_ID = "saju-2f05aa8269cf98748a2c";
